export default {
    action     : 'MFEApp-Api',
    queryString: '',
    locale     : 'en_US',
    data       : [
        {
            eventId      : 144508,
            hashedEventId: 'wvq43ABOkd',
            shiptoId     : '547216',
            shipto       : {
                name          : 'THE LINKS AT LAKEHOUSE',
                shiptoId      : '547216',
                salesChannel  : 'Territory',
                billtoId      : '618487',
                address1      : '1750 SAN PABLO DR.',
                address2      : null,
                address3      : null,
                city          : 'San Marcos',
                state         : 'CA',
                postalCode    : '92078',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 94323,
                    email    : 'mbarnhart@stmarkgolf.com',
                    firstName: 'Mark',
                    lastName : 'Barnhart',
                    isPro    : true
                }
            ],
            locationId         : 10432,
            eventName          : 'The Links at Lakehouse',
            address1           : '1750 SAN PABLO DR.',
            city               : 'San Marcos',
            postalCode         : '92078',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.124265,
            longitude          : -117.2032506,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-06T20:39:17Z',
            updatedDate        : '2025-01-13T16:52:08Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.5,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 6.88644069320561,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-01-23T10:00:00Z',
            scheduledEnd      : '2025-01-23T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/wvq43ABOkd',
            golfProEmail      : 'mbarnhart@stmarkgolf.com',
            golfProFirstName  : 'Mark',
            golfProLastName   : 'Barnhart',
            fitterCount       : 2,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 7,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/wvq43ABOkd/add_to_calendar',
            id               : 144508,
            shipTo           : '547216',
            specsVisibilityId: 1,
            location         : {
                id        : 10432,
                name      : 'The Links at Lakehouse',
                address1  : '1750 SAN PABLO DR.',
                address2  : null,
                address3  : null,
                city      : 'San Marcos',
                postalCode: '92078',
                state     : 'CA',
                shipTo    : '547216',
                latitude  : 33.124265,
                longitude : -117.2032506,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 144507,
            hashedEventId: 'gjkD7raVKx',
            shiptoId     : '547216',
            shipto       : {
                name          : 'THE LINKS AT LAKEHOUSE',
                shiptoId      : '547216',
                salesChannel  : 'Territory',
                billtoId      : '618487',
                address1      : '1750 SAN PABLO DR.',
                address2      : null,
                address3      : null,
                city          : 'San Marcos',
                state         : 'CA',
                postalCode    : '92078',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 94323,
                    email    : 'mbarnhart@stmarkgolf.com',
                    firstName: 'Mark',
                    lastName : 'Barnhart',
                    isPro    : true
                }
            ],
            locationId         : 10432,
            eventName          : 'The Links at Lakehouse',
            address1           : '1750 SAN PABLO DR.',
            city               : 'San Marcos',
            postalCode         : '92078',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.124265,
            longitude          : -117.2032506,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-06T20:37:36Z',
            updatedDate        : '2024-12-06T20:38:31Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 6.88644069320561,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-03-03T10:00:00Z',
            scheduledEnd      : '2025-03-03T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/gjkD7raVKx',
            golfProEmail      : 'mbarnhart@stmarkgolf.com',
            golfProFirstName  : 'Mark',
            golfProLastName   : 'Barnhart',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/gjkD7raVKx/add_to_calendar',
            id               : 144507,
            shipTo           : '547216',
            specsVisibilityId: 1,
            location         : {
                id        : 10432,
                name      : 'The Links at Lakehouse',
                address1  : '1750 SAN PABLO DR.',
                address2  : null,
                address3  : null,
                city      : 'San Marcos',
                postalCode: '92078',
                state     : 'CA',
                shipTo    : '547216',
                latitude  : 33.124265,
                longitude : -117.2032506,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 149081,
            hashedEventId: 'V1kbnDYQka',
            shiptoId     : '544298',
            shipto       : {
                name          : 'ARROWOOD GOLF COURSE',
                shiptoId      : '544298',
                salesChannel  : 'Territory',
                billtoId      : '616762',
                address1      : '5201 A VILLAGE DRIVE',
                address2      : null,
                address3      : null,
                city          : 'Oceanside',
                state         : 'CA',
                postalCode    : '92057',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 408179,
                    email    : 'kalter@arrowoodgolf.com',
                    firstName: 'Kate',
                    lastName : 'Alter',
                    isPro    : true
                }
            ],
            locationId         : 30723,
            eventName          : 'ARROWOOD GOLF COURSE',
            address1           : '5201 A VILLAGE DRIVE',
            city               : 'Oceanside',
            postalCode         : '92057',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.2736718,
            longitude          : -117.2876766,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2025-01-15T01:11:40Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 9.348836179674999,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-02-10T10:00:00Z',
            scheduledEnd      : '2025-02-10T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/V1kbnDYQka',
            golfProEmail      : 'kalter@arrowoodgolf.com',
            golfProFirstName  : 'Kate',
            golfProLastName   : 'Alter',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/V1kbnDYQka/add_to_calendar',
            id               : 149081,
            shipTo           : '544298',
            specsVisibilityId: 1,
            location         : {
                id        : 30723,
                name      : 'ARROWOOD GOLF COURSE',
                address1  : '5201 A VILLAGE DRIVE',
                address2  : null,
                address3  : null,
                city      : 'Oceanside',
                postalCode: '92057',
                state     : 'CA',
                shipTo    : '544298',
                latitude  : 33.2736718,
                longitude : -117.2876766,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 147250,
            hashedEventId: 'QaZG7Qo2ZA',
            shiptoId     : '554554',
            shipto       : {
                name          : '05 ESC GOLF MART ESCONDIDO',
                shiptoId      : '554554',
                salesChannel  : 'Strategic',
                billtoId      : '603113',
                address1      : '1066 W. VALLEY PKWY',
                address2      : 'EDI-05',
                address3      : null,
                city          : 'Escondido',
                state         : 'CA',
                postalCode    : '92025',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Strategic',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 1717,
                    email    : 'escondido@thegolfmart.com',
                    firstName: 'Craig',
                    lastName : 'Buckley',
                    isPro    : true
                }
            ],
            locationId         : 30082,
            eventName          : '05 ESC GOLF MART ESCONDIDO',
            address1           : '1066 W. VALLEY PKWY',
            address2           : 'EDI-05',
            city               : 'Escondido',
            postalCode         : '92025',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.117578,
            longitude          : -117.0976342,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2025-01-04T17:43:17Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 13.001787217047799,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-02-18T10:00:00Z',
            scheduledEnd      : '2025-02-18T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/QaZG7Qo2ZA',
            golfProEmail      : 'escondido@thegolfmart.com',
            golfProFirstName  : 'Craig',
            golfProLastName   : 'Buckley',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : true,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/QaZG7Qo2ZA/add_to_calendar',
            id               : 147250,
            shipTo           : '554554',
            specsVisibilityId: 1,
            location         : {
                id        : 30082,
                name      : '05 ESC GOLF MART ESCONDIDO',
                address1  : '1066 W. VALLEY PKWY',
                address2  : 'EDI-05',
                address3  : null,
                city      : 'Escondido',
                postalCode: '92025',
                state     : 'CA',
                shipTo    : '554554',
                latitude  : 33.117578,
                longitude : -117.0976342,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 146486,
            hashedEventId: 'jXqrevR2ko',
            shiptoId     : '700452',
            shipto       : {
                name          : 'OAKS NORTH RPO',
                shiptoId      : '700452',
                salesChannel  : 'Territory',
                billtoId      : '400452',
                address1      : '12602 OAKS NORTH DRIVE',
                address2      : null,
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92128',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 174148,
                    email    : 'slyons@jcresorts.com',
                    firstName: 'Steve',
                    lastName : 'Lyons',
                    isPro    : true
                }
            ],
            locationId         : 31716,
            eventName          : 'OAKS NORTH RPO',
            address1           : '12602 OAKS NORTH DRIVE',
            city               : 'San Diego',
            postalCode         : '92128',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.0337719,
            longitude          : -117.0566347,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-27T01:43:48Z',
            updatedDate        : '2025-01-06T23:41:07Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.5,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 16.98747354259613,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-01-24T10:00:00Z',
            scheduledEnd      : '2025-01-24T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/jXqrevR2ko',
            golfProEmail      : 'slyons@jcresorts.com',
            golfProFirstName  : 'Steve',
            golfProLastName   : 'Lyons',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 3,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/jXqrevR2ko/add_to_calendar',
            id               : 146486,
            shipTo           : '700452',
            specsVisibilityId: 1,
            location         : {
                id        : 31716,
                name      : 'OAKS NORTH RPO',
                address1  : '12602 OAKS NORTH DRIVE',
                address2  : null,
                address3  : null,
                city      : 'San Diego',
                postalCode: '92128',
                state     : 'CA',
                shipTo    : '700452',
                latitude  : 33.0337719,
                longitude : -117.0566347,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 146487,
            hashedEventId: 'l0q1Qr7Oq2',
            shiptoId     : '700452',
            shipto       : {
                name          : 'OAKS NORTH RPO',
                shiptoId      : '700452',
                salesChannel  : 'Territory',
                billtoId      : '400452',
                address1      : '12602 OAKS NORTH DRIVE',
                address2      : null,
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92128',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 174148,
                    email    : 'slyons@jcresorts.com',
                    firstName: 'Steve',
                    lastName : 'Lyons',
                    isPro    : true
                }
            ],
            locationId         : 31716,
            eventName          : 'OAKS NORTH RPO',
            address1           : '12602 OAKS NORTH DRIVE',
            city               : 'San Diego',
            postalCode         : '92128',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.0337719,
            longitude          : -117.0566347,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-27T01:44:44Z',
            updatedDate        : '2025-01-06T23:41:18Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 16.98747354259613,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-02-28T10:00:00Z',
            scheduledEnd      : '2025-02-28T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/l0q1Qr7Oq2',
            golfProEmail      : 'slyons@jcresorts.com',
            golfProFirstName  : 'Steve',
            golfProLastName   : 'Lyons',
            fitterCount       : 2,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/l0q1Qr7Oq2/add_to_calendar',
            id               : 146487,
            shipTo           : '700452',
            specsVisibilityId: 1,
            location         : {
                id        : 31716,
                name      : 'OAKS NORTH RPO',
                address1  : '12602 OAKS NORTH DRIVE',
                address2  : null,
                address3  : null,
                city      : 'San Diego',
                postalCode: '92128',
                state     : 'CA',
                shipTo    : '700452',
                latitude  : 33.0337719,
                longitude : -117.0566347,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 146488,
            hashedEventId: 'Q1KNBabjKw',
            shiptoId     : '700452',
            shipto       : {
                name          : 'OAKS NORTH RPO',
                shiptoId      : '700452',
                salesChannel  : 'Territory',
                billtoId      : '400452',
                address1      : '12602 OAKS NORTH DRIVE',
                address2      : null,
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92128',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 174148,
                    email    : 'slyons@jcresorts.com',
                    firstName: 'Steve',
                    lastName : 'Lyons',
                    isPro    : true
                }
            ],
            locationId         : 31716,
            eventName          : 'OAKS NORTH RPO',
            address1           : '12602 OAKS NORTH DRIVE',
            city               : 'San Diego',
            postalCode         : '92128',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.0337719,
            longitude          : -117.0566347,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-27T01:45:14Z',
            updatedDate        : '2025-01-06T23:41:28Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 16.98747354259613,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-03-28T10:00:00Z',
            scheduledEnd      : '2025-03-28T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/Q1KNBabjKw',
            golfProEmail      : 'slyons@jcresorts.com',
            golfProFirstName  : 'Steve',
            golfProLastName   : 'Lyons',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/Q1KNBabjKw/add_to_calendar',
            id               : 146488,
            shipTo           : '700452',
            specsVisibilityId: 1,
            location         : {
                id        : 31716,
                name      : 'OAKS NORTH RPO',
                address1  : '12602 OAKS NORTH DRIVE',
                address2  : null,
                address3  : null,
                city      : 'San Diego',
                postalCode: '92128',
                state     : 'CA',
                shipTo    : '700452',
                latitude  : 33.0337719,
                longitude : -117.0566347,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 144468,
            hashedEventId: 'ApZAbnwNKd',
            shiptoId     : '514852',
            shipto       : {
                name          : 'MADERAS GOLF CLUB',
                shiptoId      : '514852',
                salesChannel  : 'Territory',
                billtoId      : '609371',
                address1      : '17750 OLD COACH ROAD',
                address2      : null,
                address3      : null,
                city          : 'Poway',
                state         : 'CA',
                postalCode    : '92064',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 583016,
                    email    : 'mmatranga@maderasgolf.com',
                    firstName: 'Michael',
                    lastName : 'Matranga',
                    isPro    : true
                }
            ],
            locationId         : 29589,
            eventName          : 'MADERAS GOLF CLUB',
            address1           : '17750 OLD COACH ROAD',
            city               : 'Poway',
            postalCode         : '92064',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.0357111,
            longitude          : -117.0241846,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-06T19:21:55Z',
            updatedDate        : '2025-01-09T15:43:34Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.5625,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 18.64244788501998,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-01-17T10:00:00Z',
            scheduledEnd      : '2025-01-17T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/ApZAbnwNKd',
            golfProEmail      : 'mmatranga@maderasgolf.com',
            golfProFirstName  : 'Michael',
            golfProLastName   : 'Matranga',
            fitterCount       : 2,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 7,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/ApZAbnwNKd/add_to_calendar',
            id               : 144468,
            shipTo           : '514852',
            specsVisibilityId: 1,
            location         : {
                id        : 29589,
                name      : 'MADERAS GOLF CLUB',
                address1  : '17750 OLD COACH ROAD',
                address2  : null,
                address3  : null,
                city      : 'Poway',
                postalCode: '92064',
                state     : 'CA',
                shipTo    : '514852',
                latitude  : 33.0357111,
                longitude : -117.0241846,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 144469,
            hashedEventId: 'M4kzlwDVZL',
            shiptoId     : '514852',
            shipto       : {
                name          : 'MADERAS GOLF CLUB',
                shiptoId      : '514852',
                salesChannel  : 'Territory',
                billtoId      : '609371',
                address1      : '17750 OLD COACH ROAD',
                address2      : null,
                address3      : null,
                city          : 'Poway',
                state         : 'CA',
                postalCode    : '92064',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 583016,
                    email    : 'mmatranga@maderasgolf.com',
                    firstName: 'Michael',
                    lastName : 'Matranga',
                    isPro    : true
                }
            ],
            locationId         : 29589,
            eventName          : 'MADERAS GOLF CLUB',
            address1           : '17750 OLD COACH ROAD',
            city               : 'Poway',
            postalCode         : '92064',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.0357111,
            longitude          : -117.0241846,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-12-06T19:23:25Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.25,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 18.64244788501998,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-02-22T10:00:00Z',
            scheduledEnd      : '2025-02-22T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/M4kzlwDVZL',
            golfProEmail      : 'mmatranga@maderasgolf.com',
            golfProFirstName  : 'Michael',
            golfProLastName   : 'Matranga',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 2,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/M4kzlwDVZL/add_to_calendar',
            id               : 144469,
            shipTo           : '514852',
            specsVisibilityId: 1,
            location         : {
                id        : 29589,
                name      : 'MADERAS GOLF CLUB',
                address1  : '17750 OLD COACH ROAD',
                address2  : null,
                address3  : null,
                city      : 'Poway',
                postalCode: '92064',
                state     : 'CA',
                shipTo    : '514852',
                latitude  : 33.0357111,
                longitude : -117.0241846,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 140064,
            hashedEventId: '64K2oBVPkX',
            shiptoId     : '502328',
            shipto       : {
                name          : 'FAIRWAY GOLF, INC',
                shiptoId      : '502328',
                salesChannel  : 'Territory',
                billtoId      : '601720',
                address1      : '5040 CONVOY ST.',
                address2      : 'SUITE A',
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92111',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 361581,
                    email    : 'goto@fairwaygolf.com',
                    firstName: 'Jun',
                    lastName : 'Goto',
                    isPro    : true
                }
            ],
            locationId         : 25726,
            eventName          : 'FAIRWAY GOLF, INC',
            address1           : '5040 CONVOY ST.',
            address2           : 'SUITE A',
            city               : 'San Diego',
            postalCode         : '92111',
            state              : 'CA',
            country            : 'US',
            latitude           : 32.833538,
            longitude          : -117.1537493,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-10-09T02:57:13Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.25,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 23.35705364180552,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-03-14T10:00:00Z',
            scheduledEnd      : '2025-03-14T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/64K2oBVPkX',
            golfProEmail      : 'goto@fairwaygolf.com',
            golfProFirstName  : 'Jun',
            golfProLastName   : 'Goto',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : true,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 1,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/64K2oBVPkX/add_to_calendar',
            id               : 140064,
            shipTo           : '502328',
            specsVisibilityId: 1,
            location         : {
                id        : 25726,
                name      : 'FAIRWAY GOLF, INC',
                address1  : '5040 CONVOY ST.',
                address2  : 'SUITE A',
                address3  : null,
                city      : 'San Diego',
                postalCode: '92111',
                state     : 'CA',
                shipTo    : '502328',
                latitude  : 32.833538,
                longitude : -117.1537493,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 140065,
            hashedEventId: 'jPZ08BOLZ1',
            shiptoId     : '502328',
            shipto       : {
                name          : 'FAIRWAY GOLF, INC',
                shiptoId      : '502328',
                salesChannel  : 'Territory',
                billtoId      : '601720',
                address1      : '5040 CONVOY ST.',
                address2      : 'SUITE A',
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92111',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 361581,
                    email    : 'goto@fairwaygolf.com',
                    firstName: 'Jun',
                    lastName : 'Goto',
                    isPro    : true
                }
            ],
            locationId         : 25726,
            eventName          : 'FAIRWAY GOLF, INC',
            address1           : '5040 CONVOY ST.',
            address2           : 'SUITE A',
            city               : 'San Diego',
            postalCode         : '92111',
            state              : 'CA',
            country            : 'US',
            latitude           : 32.833538,
            longitude          : -117.1537493,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-10-09T02:59:19Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.125,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 23.35705364180552,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-05-31T10:00:00Z',
            scheduledEnd      : '2025-05-31T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/jPZ08BOLZ1',
            golfProEmail      : 'goto@fairwaygolf.com',
            golfProFirstName  : 'Jun',
            golfProLastName   : 'Goto',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : true,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 1,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/jPZ08BOLZ1/add_to_calendar',
            id               : 140065,
            shipTo           : '502328',
            specsVisibilityId: 1,
            location         : {
                id        : 25726,
                name      : 'FAIRWAY GOLF, INC',
                address1  : '5040 CONVOY ST.',
                address2  : 'SUITE A',
                address3  : null,
                city      : 'San Diego',
                postalCode: '92111',
                state     : 'CA',
                shipTo    : '502328',
                latitude  : 32.833538,
                longitude : -117.1537493,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 140066,
            hashedEventId: 'VlkY9EVyk5',
            shiptoId     : '502328',
            shipto       : {
                name          : 'FAIRWAY GOLF, INC',
                shiptoId      : '502328',
                salesChannel  : 'Territory',
                billtoId      : '601720',
                address1      : '5040 CONVOY ST.',
                address2      : 'SUITE A',
                address3      : null,
                city          : 'San Diego',
                state         : 'CA',
                postalCode    : '92111',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 361581,
                    email    : 'goto@fairwaygolf.com',
                    firstName: 'Jun',
                    lastName : 'Goto',
                    isPro    : true
                }
            ],
            locationId         : 25726,
            eventName          : 'FAIRWAY GOLF, INC',
            address1           : '5040 CONVOY ST.',
            address2           : 'SUITE A',
            city               : 'San Diego',
            postalCode         : '92111',
            state              : 'CA',
            country            : 'US',
            latitude           : 32.833538,
            longitude          : -117.1537493,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-10-09T03:00:37Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 23.35705364180552,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-10-17T10:00:00Z',
            scheduledEnd      : '2025-10-17T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/VlkY9EVyk5',
            golfProEmail      : 'goto@fairwaygolf.com',
            golfProFirstName  : 'Jun',
            golfProLastName   : 'Goto',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : true,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/VlkY9EVyk5/add_to_calendar',
            id               : 140066,
            shipTo           : '502328',
            specsVisibilityId: 1,
            location         : {
                id        : 25726,
                name      : 'FAIRWAY GOLF, INC',
                address1  : '5040 CONVOY ST.',
                address2  : 'SUITE A',
                address3  : null,
                city      : 'San Diego',
                postalCode: '92111',
                state     : 'CA',
                shipTo    : '502328',
                latitude  : 32.833538,
                longitude : -117.1537493,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 141701,
            hashedEventId: 'gOqW53WRKG',
            shiptoId     : '020610',
            shipto       : {
                name          : 'SAN CLEMENTE MUNI C C',
                shiptoId      : '020610',
                salesChannel  : 'Territory',
                billtoId      : '036910',
                address1      : '150 MAGDALENA',
                address2      : null,
                address3      : null,
                city          : 'San Clemente',
                state         : 'CA',
                postalCode    : '92672',
                country       : 'US',
                salesTerritory: 'TM-46'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 610987,
                    email    : 'vinnie@vinniepga.com',
                    firstName: 'Vinnie',
                    lastName : 'Poncino',
                    isPro    : true
                },
                {
                    userId   : 31807,
                    email    : 'eric.brambila@taylormadegolf.com',
                    firstName: 'Eric',
                    lastName : 'Brambila',
                    isPro    : false
                }
            ],
            locationId         : 29065,
            eventName          : 'SAN CLEMENTE MUNI C C',
            address1           : '150 MAGDALENA',
            city               : 'San Clemente',
            postalCode         : '92672',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.4097675,
            longitude          : -117.5981984,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2024-10-31T19:09:35Z',
            updatedDate        : '2025-01-12T21:14:44Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.7,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 24.532736125379117,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-01-30T10:00:00Z',
            scheduledEnd      : '2025-01-30T15:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/gOqW53WRKG',
            golfProEmail      : 'vinnie@vinniepga.com',
            golfProFirstName  : 'Vinnie',
            golfProLastName   : 'Poncino',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 4,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/gOqW53WRKG/add_to_calendar',
            id               : 141701,
            shipTo           : '020610',
            specsVisibilityId: 1,
            location         : {
                id        : 29065,
                name      : 'SAN CLEMENTE MUNI C C',
                address1  : '150 MAGDALENA',
                address2  : null,
                address3  : null,
                city      : 'San Clemente',
                postalCode: '92672',
                state     : 'CA',
                shipTo    : '020610',
                latitude  : 33.4097675,
                longitude : -117.5981984,
                country   : 'US',
                accuracy  : 'ROOFTOP',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 148420,
            hashedEventId: '64K2oJpAkX',
            shiptoId     : '094730',
            shipto       : {
                name          : 'TEMECULA CREEK INN RPO',
                shiptoId      : '094730',
                salesChannel  : 'Territory',
                billtoId      : '202475',
                address1      : '44501 RAINBOW CANYON RD',
                address2      : 'PECHANGA RESORTS INC.',
                address3      : null,
                city          : 'Temecula',
                state         : 'CA',
                postalCode    : '92592',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 116035,
                    email    : 'pwininger@tciresort.com',
                    firstName: 'peter',
                    lastName : 'Wininger',
                    isPro    : true
                }
            ],
            locationId         : 29471,
            eventName          : 'TEMECULA CREEK INN RPO',
            address1           : '44501 RAINBOW CANYON RD',
            address2           : 'PECHANGA RESORTS INC.',
            city               : 'Temecula',
            postalCode         : '92592',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.4717916,
            longitude          : -117.127457,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2025-01-10T18:48:47Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 25.421495038256523,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-03-01T10:00:00Z',
            scheduledEnd      : '2025-03-01T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/64K2oJpAkX',
            golfProEmail      : 'pwininger@tciresort.com',
            golfProFirstName  : 'peter',
            golfProLastName   : 'Wininger',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/64K2oJpAkX/add_to_calendar',
            id               : 148420,
            shipTo           : '094730',
            specsVisibilityId: 1,
            location         : {
                id        : 29471,
                name      : 'TEMECULA CREEK INN RPO',
                address1  : '44501 RAINBOW CANYON RD',
                address2  : 'PECHANGA RESORTS INC.',
                address3  : null,
                city      : 'Temecula',
                postalCode: '92592',
                state     : 'CA',
                shipTo    : '094730',
                latitude  : 33.4717916,
                longitude : -117.127457,
                country   : 'US',
                accuracy  : 'RANGE_INTERPOLATED',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 148421,
            hashedEventId: 'jPZ08g4GZ1',
            shiptoId     : '094730',
            shipto       : {
                name          : 'TEMECULA CREEK INN RPO',
                shiptoId      : '094730',
                salesChannel  : 'Territory',
                billtoId      : '202475',
                address1      : '44501 RAINBOW CANYON RD',
                address2      : 'PECHANGA RESORTS INC.',
                address3      : null,
                city          : 'Temecula',
                state         : 'CA',
                postalCode    : '92592',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Territory',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 116035,
                    email    : 'pwininger@tciresort.com',
                    firstName: 'peter',
                    lastName : 'Wininger',
                    isPro    : true
                }
            ],
            locationId         : 29471,
            eventName          : 'TEMECULA CREEK INN RPO',
            address1           : '44501 RAINBOW CANYON RD',
            address2           : 'PECHANGA RESORTS INC.',
            city               : 'Temecula',
            postalCode         : '92592',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.4717916,
            longitude          : -117.127457,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2025-01-10T18:50:32Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.0,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 25.421495038256523,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-04-19T10:00:00Z',
            scheduledEnd      : '2025-04-19T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/jPZ08g4GZ1',
            golfProEmail      : 'pwininger@tciresort.com',
            golfProFirstName  : 'peter',
            golfProLastName   : 'Wininger',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : false,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 0,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/jPZ08g4GZ1/add_to_calendar',
            id               : 148421,
            shipTo           : '094730',
            specsVisibilityId: 1,
            location         : {
                id        : 29471,
                name      : 'TEMECULA CREEK INN RPO',
                address1  : '44501 RAINBOW CANYON RD',
                address2  : 'PECHANGA RESORTS INC.',
                address3  : null,
                city      : 'Temecula',
                postalCode: '92592',
                state     : 'CA',
                shipTo    : '094730',
                latitude  : 33.4717916,
                longitude : -117.127457,
                country   : 'US',
                accuracy  : 'RANGE_INTERPOLATED',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        },
        {
            eventId      : 147251,
            hashedEventId: 'gjkD7521Kx',
            shiptoId     : '590241',
            shipto       : {
                name          : 'ROGER DUNN TEMECULA 185',
                shiptoId      : '590241',
                salesChannel  : 'Strategic',
                billtoId      : '603113',
                address1      : '26447 YNEZ RD.',
                address2      : null,
                address3      : null,
                city          : 'Temecula',
                state         : 'CA',
                postalCode    : '92591',
                country       : 'US',
                salesTerritory: 'TM-48'
            },
            shiptoSalesChannel: 'Strategic',
            eventAdmins       : [
                {
                    userId   : 50898,
                    email    : 'tom.severson@taylormadegolf.com',
                    firstName: 'tom',
                    lastName : 'severson',
                    isPro    : false
                },
                {
                    userId   : 939835,
                    email    : 'cnovotny@wgs.com',
                    firstName: 'Chris',
                    lastName : 'Novotny',
                    isPro    : true
                }
            ],
            locationId         : 31044,
            eventName          : 'ROGER DUNN TEMECULA 185',
            address1           : '2675 YNEZ RD. Suite A',
            city               : 'Temecula',
            postalCode         : '92591',
            state              : 'CA',
            country            : 'US',
            latitude           : 33.5199031,
            longitude          : -117.1565865,
            fittingDurationOpt : { id: 15, name: '60/30mins: Full Bag, Woods, Irons, Wedge, Putter' },
            createdDate        : '2025-01-04T17:48:58Z',
            onsiteClubBuilding : false,
            languageCode       : 'en',
            phNumBookingReqName: 'OPTIONAL',
            currencyCode       : 'USD',
            phNumBookingReq    : { id: 3, name: 'OPTIONAL' },
            bookedPercentage   : 0.125,
            completedPercentage: 0.0,
            fittingTypes       : [
                { id: 2, name: 'Wood', displayName: 'WOODS ONLY', sortOrder: 1 },
                { id: 3, name: 'Iron', displayName: 'IRONS ONLY', sortOrder: 2 },
                { id: 1, name: 'Full', displayName: 'FULL BAG', sortOrder: 3 },
                { id: 6, name: 'Wedge', displayName: 'WEDGE', sortOrder: 6 },
                { id: 7, name: 'Putter', displayName: 'PUTTER', sortOrder: 7 }
            ],
            selfBookable      : true,
            bookabilityLevelId: 1,
            distanceToLocator : 27.829633244103153,
            locator           : {
                centerLatitude : 33.1412124,
                centerLongitude: -117.3205123,
                radius         : 50.0,
                unit           : 'MILE'
            },
            eventTypeId       : 1,
            scheduledStart    : '2025-02-20T10:00:00Z',
            scheduledEnd      : '2025-02-20T14:00:00Z',
            shareLink         : 'https://myfittingexp.taylormadegolf.com/fitting/private/gjkD7521Kx',
            golfProEmail      : 'cnovotny@wgs.com',
            golfProFirstName  : 'Chris',
            golfProLastName   : 'Novotny',
            fitterCount       : 1,
            eventProductTypeId: 1,
            indoor            : true,
            businessUnitCode  : 'TM',
            active            : true,
            fittingsCount     : 1,
            addToCalendarLink :
        'https://my.taylormadegolf.com/myFittingExp/event/gjkD7521Kx/add_to_calendar',
            id               : 147251,
            shipTo           : '590241',
            specsVisibilityId: 1,
            location         : {
                id        : 31044,
                name      : 'ROGER DUNN TEMECULA 185',
                address1  : '2675 YNEZ RD. Suite A',
                address2  : null,
                address3  : null,
                city      : 'Temecula',
                postalCode: '92591',
                state     : 'CA',
                shipTo    : '590241',
                latitude  : 33.5199031,
                longitude : -117.1565865,
                country   : 'US',
                accuracy  : 'GEOMETRIC_CENTER',
                timeZoneId: 3
            },
            fittingFeeLevel: { id: 0, name: 'N/A', partBagFee: 0.0, fullBagFee: 0.0, currencyCode: 'USD' }
        }
    ]
};
